import BaseExecutor from 'services/sports/default/base-executor';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import {SingleGameValidatorBuilder} from 'services/validations/builders/single-game-validator-builder';
import {ForcedStackingValidatorBuilder} from 'services/sports/singlegame/validator/forced-stacking-validator-builder';

export default class UserAdjustmentsValidatorSinglegameBuilder extends BaseExecutor {
    getInterface() {
        const {
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const singleGameValidatorBuilder = new SingleGameValidatorBuilder({
            exposureMinPropNames: ['exposureMin', 'captain_exposureMin'],
        }).getInterface();
        validator.addSubValidators([singleGameValidatorBuilder]);

        if (stacking.isEnabled()) {
            const forcedStackingValidatorBuilder = new ForcedStackingValidatorBuilder().getInterface();
            validator.addSubValidators([forcedStackingValidatorBuilder]);
        }

        return validator;
    }
}
